
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire629d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire629d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2T347", function(module, exports) {
(function(global1) {
    /**
   * Polyfill URLSearchParams
   *
   * Inspired from : https://github.com/WebReflection/url-search-params/blob/master/src/url-search-params.js
   */ var checkIfIteratorIsSupported = function() {
        try {
            return !!Symbol.iterator;
        } catch (error) {
            return false;
        }
    };
    var iteratorSupported = checkIfIteratorIsSupported();
    var createIterator = function(items) {
        var iterator = {
            next: function() {
                var value = items.shift();
                return {
                    done: value === void 0,
                    value: value
                };
            }
        };
        if (iteratorSupported) iterator[Symbol.iterator] = function() {
            return iterator;
        };
        return iterator;
    };
    /**
   * Search param name and values should be encoded according to https://url.spec.whatwg.org/#urlencoded-serializing
   * encodeURIComponent() produces the same result except encoding spaces as `%20` instead of `+`.
   */ var serializeParam = function(value) {
        return encodeURIComponent(value).replace(/%20/g, "+");
    };
    var deserializeParam = function(value) {
        return decodeURIComponent(String(value).replace(/\+/g, " "));
    };
    var polyfillURLSearchParams = function() {
        var URLSearchParams = function(searchString) {
            Object.defineProperty(this, "_entries", {
                writable: true,
                value: {}
            });
            var typeofSearchString = typeof searchString;
            if (typeofSearchString === "undefined") ;
            else if (typeofSearchString === "string") {
                if (searchString !== "") this._fromString(searchString);
            } else if (searchString instanceof URLSearchParams) {
                var _this = this;
                searchString.forEach(function(value, name) {
                    _this.append(name, value);
                });
            } else if (searchString !== null && typeofSearchString === "object") {
                if (Object.prototype.toString.call(searchString) === "[object Array]") for(var i = 0; i < searchString.length; i++){
                    var entry = searchString[i];
                    if (Object.prototype.toString.call(entry) === "[object Array]" || entry.length !== 2) this.append(entry[0], entry[1]);
                    else throw new TypeError("Expected [string, any] as entry at index " + i + " of URLSearchParams's input");
                }
                else {
                    for(var key in searchString)if (searchString.hasOwnProperty(key)) this.append(key, searchString[key]);
                }
            } else throw new TypeError("Unsupported input's type for URLSearchParams");
        };
        var proto = URLSearchParams.prototype;
        proto.append = function(name, value) {
            if (name in this._entries) this._entries[name].push(String(value));
            else this._entries[name] = [
                String(value)
            ];
        };
        proto.delete = function(name) {
            delete this._entries[name];
        };
        proto.get = function(name) {
            return name in this._entries ? this._entries[name][0] : null;
        };
        proto.getAll = function(name) {
            return name in this._entries ? this._entries[name].slice(0) : [];
        };
        proto.has = function(name) {
            return name in this._entries;
        };
        proto.set = function(name, value) {
            this._entries[name] = [
                String(value)
            ];
        };
        proto.forEach = function(callback, thisArg) {
            var entries;
            for(var name in this._entries)if (this._entries.hasOwnProperty(name)) {
                entries = this._entries[name];
                for(var i = 0; i < entries.length; i++)callback.call(thisArg, entries[i], name, this);
            }
        };
        proto.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return createIterator(items);
        };
        proto.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return createIterator(items);
        };
        proto.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return createIterator(items);
        };
        if (iteratorSupported) proto[Symbol.iterator] = proto.entries;
        proto.toString = function() {
            var searchArray = [];
            this.forEach(function(value, name) {
                searchArray.push(serializeParam(name) + "=" + serializeParam(value));
            });
            return searchArray.join("&");
        };
        global1.URLSearchParams = URLSearchParams;
    };
    var checkIfURLSearchParamsSupported = function() {
        try {
            var URLSearchParams = global1.URLSearchParams;
            return new URLSearchParams("?a=1").toString() === "a=1" && typeof URLSearchParams.prototype.set === "function" && typeof URLSearchParams.prototype.entries === "function";
        } catch (e) {
            return false;
        }
    };
    if (!checkIfURLSearchParamsSupported()) polyfillURLSearchParams();
    var proto = global1.URLSearchParams.prototype;
    if (typeof proto.sort !== "function") proto.sort = function() {
        var _this = this;
        var items = [];
        this.forEach(function(value, name) {
            items.push([
                name,
                value
            ]);
            if (!_this._entries) _this.delete(name);
        });
        items.sort(function(a, b) {
            if (a[0] < b[0]) return -1;
            else if (a[0] > b[0]) return 1;
            else return 0;
        });
        if (_this._entries) _this._entries = {};
        for(var i = 0; i < items.length; i++)this.append(items[i][0], items[i][1]);
    };
    if (typeof proto._fromString !== "function") Object.defineProperty(proto, "_fromString", {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function(searchString) {
            if (this._entries) this._entries = {};
            else {
                var keys = [];
                this.forEach(function(value, name) {
                    keys.push(name);
                });
                for(var i = 0; i < keys.length; i++)this.delete(keys[i]);
            }
            searchString = searchString.replace(/^\?/, "");
            var attributes = searchString.split("&");
            var attribute;
            for(var i = 0; i < attributes.length; i++){
                attribute = attributes[i].split("=");
                this.append(deserializeParam(attribute[0]), attribute.length > 1 ? deserializeParam(attribute[1]) : "");
            }
        }
    });
// HTMLAnchorElement
})(typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : module.exports);
(function(global1) {
    /**
   * Polyfill URL
   *
   * Inspired from : https://github.com/arv/DOM-URL-Polyfill/blob/master/src/url.js
   */ var checkIfURLIsSupported = function() {
        try {
            var u = new global1.URL("b", "http://a");
            u.pathname = "c d";
            return u.href === "http://a/c%20d" && u.searchParams;
        } catch (e) {
            return false;
        }
    };
    var polyfillURL = function() {
        var _URL = global1.URL;
        var URL = function(url, base) {
            if (typeof url !== "string") url = String(url);
            if (base && typeof base !== "string") base = String(base);
            // Only create another document if the base is different from current location.
            var doc = document, baseElement;
            if (base && (global1.location === void 0 || base !== global1.location.href)) {
                base = base.toLowerCase();
                doc = document.implementation.createHTMLDocument("");
                baseElement = doc.createElement("base");
                baseElement.href = base;
                doc.head.appendChild(baseElement);
                try {
                    if (baseElement.href.indexOf(base) !== 0) throw new Error(baseElement.href);
                } catch (err) {
                    throw new Error("URL unable to set base " + base + " due to " + err);
                }
            }
            var anchorElement = doc.createElement("a");
            anchorElement.href = url;
            if (baseElement) {
                doc.body.appendChild(anchorElement);
                anchorElement.href = anchorElement.href; // force href to refresh
            }
            var inputElement = doc.createElement("input");
            inputElement.type = "url";
            inputElement.value = url;
            if (anchorElement.protocol === ":" || !/:/.test(anchorElement.href) || !inputElement.checkValidity() && !base) throw new TypeError("Invalid URL");
            Object.defineProperty(this, "_anchorElement", {
                value: anchorElement
            });
            // create a linked searchParams which reflect its changes on URL
            var searchParams = new global1.URLSearchParams(this.search);
            var enableSearchUpdate = true;
            var enableSearchParamsUpdate = true;
            var _this = this;
            [
                "append",
                "delete",
                "set"
            ].forEach(function(methodName) {
                var method = searchParams[methodName];
                searchParams[methodName] = function() {
                    method.apply(searchParams, arguments);
                    if (enableSearchUpdate) {
                        enableSearchParamsUpdate = false;
                        _this.search = searchParams.toString();
                        enableSearchParamsUpdate = true;
                    }
                };
            });
            Object.defineProperty(this, "searchParams", {
                value: searchParams,
                enumerable: true
            });
            var search = void 0;
            Object.defineProperty(this, "_updateSearchParams", {
                enumerable: false,
                configurable: false,
                writable: false,
                value: function() {
                    if (this.search !== search) {
                        search = this.search;
                        if (enableSearchParamsUpdate) {
                            enableSearchUpdate = false;
                            this.searchParams._fromString(this.search);
                            enableSearchUpdate = true;
                        }
                    }
                }
            });
        };
        var proto = URL.prototype;
        var linkURLWithAnchorAttribute = function(attributeName) {
            Object.defineProperty(proto, attributeName, {
                get: function() {
                    return this._anchorElement[attributeName];
                },
                set: function(value) {
                    this._anchorElement[attributeName] = value;
                },
                enumerable: true
            });
        };
        [
            "hash",
            "host",
            "hostname",
            "port",
            "protocol"
        ].forEach(function(attributeName) {
            linkURLWithAnchorAttribute(attributeName);
        });
        Object.defineProperty(proto, "search", {
            get: function() {
                return this._anchorElement["search"];
            },
            set: function(value) {
                this._anchorElement["search"] = value;
                this._updateSearchParams();
            },
            enumerable: true
        });
        Object.defineProperties(proto, {
            "toString": {
                get: function() {
                    var _this = this;
                    return function() {
                        return _this.href;
                    };
                }
            },
            "href": {
                get: function() {
                    return this._anchorElement.href.replace(/\?$/, "");
                },
                set: function(value) {
                    this._anchorElement.href = value;
                    this._updateSearchParams();
                },
                enumerable: true
            },
            "pathname": {
                get: function() {
                    return this._anchorElement.pathname.replace(/(^\/?)/, "/");
                },
                set: function(value) {
                    this._anchorElement.pathname = value;
                },
                enumerable: true
            },
            "origin": {
                get: function() {
                    // get expected port from protocol
                    var expectedPort = {
                        "http:": 80,
                        "https:": 443,
                        "ftp:": 21
                    }[this._anchorElement.protocol];
                    // add port to origin if, expected port is different than actual port
                    // and it is not empty f.e http://foo:8080
                    // 8080 != 80 && 8080 != ''
                    var addPortToOrigin = this._anchorElement.port != expectedPort && this._anchorElement.port !== "";
                    return this._anchorElement.protocol + "//" + this._anchorElement.hostname + (addPortToOrigin ? ":" + this._anchorElement.port : "");
                },
                enumerable: true
            },
            "password": {
                get: function() {
                    return "";
                },
                set: function(value) {},
                enumerable: true
            },
            "username": {
                get: function() {
                    return "";
                },
                set: function(value) {},
                enumerable: true
            }
        });
        URL.createObjectURL = function(blob) {
            return _URL.createObjectURL.apply(_URL, arguments);
        };
        URL.revokeObjectURL = function(url) {
            return _URL.revokeObjectURL.apply(_URL, arguments);
        };
        global1.URL = URL;
    };
    if (!checkIfURLIsSupported()) polyfillURL();
    if (global1.location !== void 0 && !("origin" in global1.location)) {
        var getOrigin = function() {
            return global1.location.protocol + "//" + global1.location.hostname + (global1.location.port ? ":" + global1.location.port : "");
        };
        try {
            Object.defineProperty(global1.location, "origin", {
                get: getOrigin,
                enumerable: true
            });
        } catch (e) {
            setInterval(function() {
                global1.location.origin = getOrigin();
            }, 100);
        }
    }
})(typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : module.exports);

});

parcelRegister("hEy27", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.ERR_IFRAME_ALREADY_ATTACHED_TO_DOM = module.exports.ERR_NOT_IN_IFRAME = module.exports.ERR_CONNECTION_TIMEOUT = module.exports.ERR_CONNECTION_DESTROYED = void 0;
var $cda0925c043a4b0e$var$HANDSHAKE = "handshake";
var $cda0925c043a4b0e$var$HANDSHAKE_REPLY = "handshake-reply";
var $cda0925c043a4b0e$var$CALL = "call";
var $cda0925c043a4b0e$var$REPLY = "reply";
var $cda0925c043a4b0e$var$FULFILLED = "fulfilled";
var $cda0925c043a4b0e$var$REJECTED = "rejected";
var $cda0925c043a4b0e$var$MESSAGE = "message";
var $cda0925c043a4b0e$var$DATA_CLONE_ERROR = "DataCloneError";
var $cda0925c043a4b0e$var$ERR_CONNECTION_DESTROYED = "ConnectionDestroyed";
module.exports.ERR_CONNECTION_DESTROYED = $cda0925c043a4b0e$var$ERR_CONNECTION_DESTROYED;
var $cda0925c043a4b0e$var$ERR_CONNECTION_TIMEOUT = "ConnectionTimeout";
module.exports.ERR_CONNECTION_TIMEOUT = $cda0925c043a4b0e$var$ERR_CONNECTION_TIMEOUT;
var $cda0925c043a4b0e$var$ERR_NOT_IN_IFRAME = "NotInIframe";
module.exports.ERR_NOT_IN_IFRAME = $cda0925c043a4b0e$var$ERR_NOT_IN_IFRAME;
var $cda0925c043a4b0e$var$ERR_IFRAME_ALREADY_ATTACHED_TO_DOM = "IframeAlreadyAttachedToDom";
module.exports.ERR_IFRAME_ALREADY_ATTACHED_TO_DOM = $cda0925c043a4b0e$var$ERR_IFRAME_ALREADY_ATTACHED_TO_DOM;
var $cda0925c043a4b0e$var$CHECK_IFRAME_IN_DOC_INTERVAL = 60000;
var $cda0925c043a4b0e$var$DEFAULT_PORTS = {
    "http:": "80",
    "https:": "443"
};
var $cda0925c043a4b0e$var$URL_REGEX = /^(https?:|file:)?\/\/([^/:]+)?(:(\d+))?/;
var $cda0925c043a4b0e$var$Penpal = {
    ERR_CONNECTION_DESTROYED: $cda0925c043a4b0e$var$ERR_CONNECTION_DESTROYED,
    ERR_CONNECTION_TIMEOUT: $cda0925c043a4b0e$var$ERR_CONNECTION_TIMEOUT,
    ERR_NOT_IN_IFRAME: $cda0925c043a4b0e$var$ERR_NOT_IN_IFRAME,
    ERR_IFRAME_ALREADY_ATTACHED_TO_DOM: $cda0925c043a4b0e$var$ERR_IFRAME_ALREADY_ATTACHED_TO_DOM,
    /**
   * Promise implementation.
   * @type {Constructor}
   */ Promise: function() {
        try {
            return window ? window.Promise : null;
        } catch (e) {
            return null;
        }
    }(),
    /**
   * Whether debug messages should be logged.
   * @type {boolean}
   */ debug: false
};
/**
 * @return {number} A unique ID (not universally unique)
 */ var $cda0925c043a4b0e$var$generateId = function() {
    var id = 0;
    return function() {
        return ++id;
    };
}();
/**
 * Logs a message.
 * @param {...*} args One or more items to log
 */ var $cda0925c043a4b0e$var$log = function log() {
    if ($cda0925c043a4b0e$var$Penpal.debug) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        (_console = console).log.apply(_console, [
            "[Penpal]"
        ].concat(args)); // eslint-disable-line no-console
    }
};
/**
 * Converts a URL into an origin.
 * @param {string} url
 * @return {string} The URL's origin
 */ var $cda0925c043a4b0e$var$getOriginFromUrl = function getOriginFromUrl(url) {
    var location = document.location;
    var regexResult = $cda0925c043a4b0e$var$URL_REGEX.exec(url);
    var protocol;
    var hostname;
    var port;
    if (regexResult) {
        // It's an absolute URL. Use the parsed info.
        // regexResult[1] will be undefined if the URL starts with //
        protocol = regexResult[1] ? regexResult[1] : location.protocol;
        hostname = regexResult[2];
        port = regexResult[4];
    } else {
        // It's a relative path. Use the current location's info.
        protocol = location.protocol;
        hostname = location.hostname;
        port = location.port;
    } // If the protocol is file, the origin is "null"
    // The origin of a document with file protocol is an opaque origin
    // and its serialization "null" [1]
    // [1] https://html.spec.whatwg.org/multipage/origin.html#origin
    if (protocol === "file:") return "null";
     // If the port is the default for the protocol, we don't want to add it to the origin string
    // or it won't match the message's event.origin.
    var portSuffix = port && port !== $cda0925c043a4b0e$var$DEFAULT_PORTS[protocol] ? ":".concat(port) : "";
    return "".concat(protocol, "//").concat(hostname).concat(portSuffix);
};
/**
 * A simplified promise class only used internally for when destroy() is called. This is
 * used to destroy connections synchronously while promises typically resolve asynchronously.
 *
 * @param {Function} executor
 * @returns {Object}
 * @constructor
 */ var $cda0925c043a4b0e$var$DestructionPromise = function DestructionPromise(executor) {
    var handlers = [];
    executor(function() {
        handlers.forEach(function(handler) {
            handler();
        });
    });
    return {
        then: function then(handler) {
            handlers.push(handler);
        }
    };
};
/**
 * Converts an error object into a plain object.
 * @param {Error} Error object.
 * @returns {Object}
 */ var $cda0925c043a4b0e$var$serializeError = function serializeError(_ref) {
    var name = _ref.name, message = _ref.message, stack = _ref.stack;
    return {
        name: name,
        message: message,
        stack: stack
    };
};
/**
 * Converts a plain object into an error object.
 * @param {Object} Object with error properties.
 * @returns {Error}
 */ var $cda0925c043a4b0e$var$deserializeError = function deserializeError(obj) {
    var deserializedError = new Error();
    Object.keys(obj).forEach(function(key) {
        return deserializedError[key] = obj[key];
    });
    return deserializedError;
};
/**
 * Augments an object with methods that match those defined by the remote. When these methods are
 * called, a "call" message will be sent to the remote, the remote's corresponding method will be
 * executed, and the method's return value will be returned via a message.
 * @param {Object} callSender Sender object that should be augmented with methods.
 * @param {Object} info Information about the local and remote windows.
 * @param {Array} methodNames Names of methods available to be called on the remote.
 * @param {Promise} destructionPromise A promise resolved when destroy() is called on the penpal
 * connection.
 * @returns {Object} The call sender object with methods that may be called.
 */ var $cda0925c043a4b0e$var$connectCallSender = function connectCallSender(callSender, info, methodNames, destroy, destructionPromise) {
    var localName = info.localName, local = info.local, remote = info.remote, remoteOrigin = info.remoteOrigin;
    var destroyed = false;
    $cda0925c043a4b0e$var$log("".concat(localName, ": Connecting call sender"));
    var createMethodProxy = function createMethodProxy(methodName) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            $cda0925c043a4b0e$var$log("".concat(localName, ": Sending ").concat(methodName, "() call")); // This handles the case where the iframe has been removed from the DOM
            // (and therefore its window closed), the consumer has not yet
            // called destroy(), and the user calls a method exposed by
            // the remote. We detect the iframe has been removed and force
            // a destroy() immediately so that the consumer sees the error saying
            // the connection has been destroyed.
            if (remote.closed) destroy();
            if (destroyed) {
                var error = new Error("Unable to send ".concat(methodName, "() call due ") + "to destroyed connection");
                error.code = $cda0925c043a4b0e$var$ERR_CONNECTION_DESTROYED;
                throw error;
            }
            return new $cda0925c043a4b0e$var$Penpal.Promise(function(resolve, reject) {
                var id = $cda0925c043a4b0e$var$generateId();
                var handleMessageEvent = function handleMessageEvent(event) {
                    if (event.source === remote && event.origin === remoteOrigin && event.data.penpal === $cda0925c043a4b0e$var$REPLY && event.data.id === id) {
                        $cda0925c043a4b0e$var$log("".concat(localName, ": Received ").concat(methodName, "() reply"));
                        local.removeEventListener($cda0925c043a4b0e$var$MESSAGE, handleMessageEvent);
                        var returnValue = event.data.returnValue;
                        if (event.data.returnValueIsError) returnValue = $cda0925c043a4b0e$var$deserializeError(returnValue);
                        (event.data.resolution === $cda0925c043a4b0e$var$FULFILLED ? resolve : reject)(returnValue);
                    }
                };
                local.addEventListener($cda0925c043a4b0e$var$MESSAGE, handleMessageEvent);
                remote.postMessage({
                    penpal: $cda0925c043a4b0e$var$CALL,
                    id: id,
                    methodName: methodName,
                    args: args
                }, remoteOrigin);
            });
        };
    };
    destructionPromise.then(function() {
        destroyed = true;
    });
    methodNames.reduce(function(api, methodName) {
        api[methodName] = createMethodProxy(methodName);
        return api;
    }, callSender);
};
/**
 * Listens for "call" messages coming from the remote, executes the corresponding method, and
 * responds with the return value.
 * @param {Object} info Information about the local and remote windows.
 * @param {Object} methods The keys are the names of the methods that can be called by the remote
 * while the values are the method functions.
 * @param {Promise} destructionPromise A promise resolved when destroy() is called on the penpal
 * connection.
 * @returns {Function} A function that may be called to disconnect the receiver.
 */ var $cda0925c043a4b0e$var$connectCallReceiver = function connectCallReceiver(info, methods, destructionPromise) {
    var localName = info.localName, local = info.local, remote = info.remote, remoteOrigin = info.remoteOrigin;
    var destroyed = false;
    $cda0925c043a4b0e$var$log("".concat(localName, ": Connecting call receiver"));
    var handleMessageEvent = function handleMessageEvent(event) {
        if (event.source === remote && event.origin === remoteOrigin && event.data.penpal === $cda0925c043a4b0e$var$CALL) {
            var _event$data = event.data, methodName = _event$data.methodName, args = _event$data.args, id = _event$data.id;
            $cda0925c043a4b0e$var$log("".concat(localName, ": Received ").concat(methodName, "() call"));
            if (methodName in methods) {
                var createPromiseHandler = function createPromiseHandler(resolution) {
                    return function(returnValue) {
                        $cda0925c043a4b0e$var$log("".concat(localName, ": Sending ").concat(methodName, "() reply"));
                        if (destroyed) {
                            // It's possible to throw an error here, but it would need to be thrown asynchronously
                            // and would only be catchable using window.onerror. This is because the consumer
                            // is merely returning a value from their method and not calling any function
                            // that they could wrap in a try-catch. Even if the consumer were to catch the error,
                            // the value of doing so is questionable. Instead, we'll just log a message.
                            $cda0925c043a4b0e$var$log("".concat(localName, ": Unable to send ").concat(methodName, "() reply due to destroyed connection"));
                            return;
                        }
                        var message = {
                            penpal: $cda0925c043a4b0e$var$REPLY,
                            id: id,
                            resolution: resolution,
                            returnValue: returnValue
                        };
                        if (resolution === $cda0925c043a4b0e$var$REJECTED && returnValue instanceof Error) {
                            message.returnValue = $cda0925c043a4b0e$var$serializeError(returnValue);
                            message.returnValueIsError = true;
                        }
                        try {
                            remote.postMessage(message, remoteOrigin);
                        } catch (err) {
                            // If a consumer attempts to send an object that's not cloneable (e.g., window),
                            // we want to ensure the receiver's promise gets rejected.
                            if (err.name === $cda0925c043a4b0e$var$DATA_CLONE_ERROR) remote.postMessage({
                                penpal: $cda0925c043a4b0e$var$REPLY,
                                id: id,
                                resolution: $cda0925c043a4b0e$var$REJECTED,
                                returnValue: $cda0925c043a4b0e$var$serializeError(err),
                                returnValueIsError: true
                            }, remoteOrigin);
                            throw err;
                        }
                    };
                };
                new $cda0925c043a4b0e$var$Penpal.Promise(function(resolve) {
                    return resolve(methods[methodName].apply(methods, args));
                }).then(createPromiseHandler($cda0925c043a4b0e$var$FULFILLED), createPromiseHandler($cda0925c043a4b0e$var$REJECTED));
            }
        }
    };
    local.addEventListener($cda0925c043a4b0e$var$MESSAGE, handleMessageEvent);
    destructionPromise.then(function() {
        destroyed = true;
        local.removeEventListener($cda0925c043a4b0e$var$MESSAGE, handleMessageEvent);
    });
};
/**
 * @typedef {Object} Child
 * @property {Promise} promise A promise which will be resolved once a connection has
 * been established.
 * @property {HTMLIframeElement} iframe The created iframe element.
 * @property {Function} destroy A method that, when called, will remove the iframe element from
 * the DOM and clean up event listeners.
 */ /**
 * Creates an iframe, loads a webpage into the URL, and attempts to establish communication with
 * the iframe.
 * @param {Object} options
 * @param {string} options.url The URL of the webpage that should be loaded into the created iframe.
 * @param {HTMLElement} [options.appendTo] The container to which the iframe should be appended.
 * @param {Object} [options.methods={}] Methods that may be called by the iframe.
 * @param {Number} [options.timeout] The amount of time, in milliseconds, Penpal should wait
 * for the child to respond before rejecting the connection promise.
 * @return {Child}
 */ $cda0925c043a4b0e$var$Penpal.connectToChild = function(_ref2) {
    var url = _ref2.url, appendTo = _ref2.appendTo, iframe = _ref2.iframe, _ref2$methods = _ref2.methods, methods = _ref2$methods === void 0 ? {} : _ref2$methods, timeout = _ref2.timeout;
    if (iframe && iframe.parentNode) {
        var error = new Error("connectToChild() must not be called with an iframe already attached to DOM");
        error.code = $cda0925c043a4b0e$var$ERR_IFRAME_ALREADY_ATTACHED_TO_DOM;
        throw error;
    }
    var destroy;
    var connectionDestructionPromise = new $cda0925c043a4b0e$var$DestructionPromise(function(resolveConnectionDestructionPromise) {
        destroy = resolveConnectionDestructionPromise;
    });
    var parent = window;
    iframe = iframe || document.createElement("iframe");
    iframe.src = url;
    var childOrigin = $cda0925c043a4b0e$var$getOriginFromUrl(url);
    var promise = new $cda0925c043a4b0e$var$Penpal.Promise(function(resolveConnectionPromise, reject) {
        var connectionTimeoutId;
        if (timeout !== undefined) connectionTimeoutId = setTimeout(function() {
            var error = new Error("Connection to child timed out after ".concat(timeout, "ms"));
            error.code = $cda0925c043a4b0e$var$ERR_CONNECTION_TIMEOUT;
            reject(error);
            destroy();
        }, timeout);
         // We resolve the promise with the call sender. If the child reconnects (for example, after
        // refreshing or navigating to another page that uses Penpal, we'll update the call sender
        // with methods that match the latest provided by the child.
        var callSender = {};
        var receiverMethodNames;
        var destroyCallReceiver;
        var handleMessage = function handleMessage(event) {
            var child = iframe.contentWindow;
            if (event.source === child && event.origin === childOrigin && event.data.penpal === $cda0925c043a4b0e$var$HANDSHAKE) {
                $cda0925c043a4b0e$var$log("Parent: Received handshake, sending reply"); // If event.origin is "null", the remote protocol is file:
                // and we must post messages with "*" as targetOrigin [1]
                // [1] https://developer.mozilla.org/fr/docs/Web/API/Window/postMessage#Utiliser_window.postMessage_dans_les_extensions
                var remoteOrigin = event.origin === "null" ? "*" : event.origin;
                event.source.postMessage({
                    penpal: $cda0925c043a4b0e$var$HANDSHAKE_REPLY,
                    methodNames: Object.keys(methods)
                }, remoteOrigin);
                var info = {
                    localName: "Parent",
                    local: parent,
                    remote: child,
                    remoteOrigin: remoteOrigin
                }; // If the child reconnected, we need to destroy the previous call receiver before setting
                // up a new one.
                if (destroyCallReceiver) destroyCallReceiver();
                 // When this promise is resolved, it will destroy the call receiver (stop listening to
                // method calls from the child) and delete its methods off the call sender.
                var callReceiverDestructionPromise = new $cda0925c043a4b0e$var$DestructionPromise(function(resolveCallReceiverDestructionPromise) {
                    connectionDestructionPromise.then(resolveCallReceiverDestructionPromise);
                    destroyCallReceiver = resolveCallReceiverDestructionPromise;
                });
                $cda0925c043a4b0e$var$connectCallReceiver(info, methods, callReceiverDestructionPromise); // If the child reconnected, we need to remove the methods from the previous call receiver
                // off the sender.
                if (receiverMethodNames) receiverMethodNames.forEach(function(receiverMethodName) {
                    delete callSender[receiverMethodName];
                });
                receiverMethodNames = event.data.methodNames;
                $cda0925c043a4b0e$var$connectCallSender(callSender, info, receiverMethodNames, destroy, connectionDestructionPromise);
                clearTimeout(connectionTimeoutId);
                resolveConnectionPromise(callSender);
            }
        };
        parent.addEventListener($cda0925c043a4b0e$var$MESSAGE, handleMessage);
        $cda0925c043a4b0e$var$log("Parent: Loading iframe");
        (appendTo || document.body).appendChild(iframe); // This is to prevent memory leaks when the iframe is removed
        // from the document and the consumer hasn't called destroy().
        // Without this, event listeners attached to the window would
        // stick around and since the event handlers have a reference
        // to the iframe in their closures, the iframe would stick around
        // too.
        var checkIframeInDocIntervalId = setInterval(function() {
            if (!document.body.contains(iframe)) {
                clearInterval(checkIframeInDocIntervalId);
                destroy();
            }
        }, $cda0925c043a4b0e$var$CHECK_IFRAME_IN_DOC_INTERVAL);
        connectionDestructionPromise.then(function() {
            if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
            parent.removeEventListener($cda0925c043a4b0e$var$MESSAGE, handleMessage);
            clearInterval(checkIframeInDocIntervalId);
            var error = new Error("Connection destroyed");
            error.code = $cda0925c043a4b0e$var$ERR_CONNECTION_DESTROYED;
            reject(error);
        });
    });
    return {
        promise: promise,
        iframe: iframe,
        destroy: destroy
    };
};
/**
 * @typedef {Object} Parent
 * @property {Promise} promise A promise which will be resolved once a connection has
 * been established.
 */ /**
 * Attempts to establish communication with the parent window.
 * @param {Object} options
 * @param {string} [options.parentOrigin=*] Valid parent origin used to restrict communication.
 * @param {Object} [options.methods={}] Methods that may be called by the parent window.
 * @param {Number} [options.timeout] The amount of time, in milliseconds, Penpal should wait
 * for the parent to respond before rejecting the connection promise.
 * @return {Parent}
 */ $cda0925c043a4b0e$var$Penpal.connectToParent = function() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$parentOrigin = _ref3.parentOrigin, parentOrigin = _ref3$parentOrigin === void 0 ? "*" : _ref3$parentOrigin, _ref3$methods = _ref3.methods, methods = _ref3$methods === void 0 ? {} : _ref3$methods, timeout = _ref3.timeout;
    if (window === window.top) {
        var error = new Error("connectToParent() must be called within an iframe");
        error.code = $cda0925c043a4b0e$var$ERR_NOT_IN_IFRAME;
        throw error;
    }
    var destroy;
    var connectionDestructionPromise = new $cda0925c043a4b0e$var$DestructionPromise(function(resolveConnectionDestructionPromise) {
        destroy = resolveConnectionDestructionPromise;
    });
    var child = window;
    var parent = child.parent;
    var promise = new $cda0925c043a4b0e$var$Penpal.Promise(function(resolveConnectionPromise, reject) {
        var connectionTimeoutId;
        if (timeout !== undefined) connectionTimeoutId = setTimeout(function() {
            var error = new Error("Connection to parent timed out after ".concat(timeout, "ms"));
            error.code = $cda0925c043a4b0e$var$ERR_CONNECTION_TIMEOUT;
            reject(error);
            destroy();
        }, timeout);
        var handleMessageEvent = function handleMessageEvent(event) {
            if ((parentOrigin === "*" || parentOrigin === event.origin) && event.source === parent && event.data.penpal === $cda0925c043a4b0e$var$HANDSHAKE_REPLY) {
                $cda0925c043a4b0e$var$log("Child: Received handshake reply");
                child.removeEventListener($cda0925c043a4b0e$var$MESSAGE, handleMessageEvent);
                var info = {
                    localName: "Child",
                    local: child,
                    remote: parent,
                    remoteOrigin: event.origin
                };
                var callSender = {};
                $cda0925c043a4b0e$var$connectCallReceiver(info, methods, connectionDestructionPromise);
                $cda0925c043a4b0e$var$connectCallSender(callSender, info, event.data.methodNames, destroy, connectionDestructionPromise);
                clearTimeout(connectionTimeoutId);
                resolveConnectionPromise(callSender);
            }
        };
        child.addEventListener($cda0925c043a4b0e$var$MESSAGE, handleMessageEvent);
        connectionDestructionPromise.then(function() {
            child.removeEventListener($cda0925c043a4b0e$var$MESSAGE, handleMessageEvent);
            var error = new Error("Connection destroyed");
            error.code = $cda0925c043a4b0e$var$ERR_CONNECTION_DESTROYED;
            reject(error);
        });
        $cda0925c043a4b0e$var$log("Child: Sending handshake");
        parent.postMessage({
            penpal: $cda0925c043a4b0e$var$HANDSHAKE,
            methodNames: Object.keys(methods)
        }, parentOrigin);
    });
    return {
        promise: promise,
        destroy: destroy
    };
};
var $cda0925c043a4b0e$var$_default = $cda0925c043a4b0e$var$Penpal;
module.exports.default = $cda0925c043a4b0e$var$_default;

});

parcelRegister("bAHo9", function(module, exports) {

$parcel$export(module.exports, "deviceIdKey", function () { return $993097c8a4cb6a2a$export$37d7f5dc77f27ca7; });
const $993097c8a4cb6a2a$export$37d7f5dc77f27ca7 = "__TOMIS__device_id";

});


//# sourceMappingURL=index.aeab2270.js.map
